package com.tovtalk.utils.extensions

import com.tovtalk.utils.constants.AppConstants

/**
 * String Extensions
 */

/**
 * Check if string is a valid email
 */
fun String.isValidEmail(): Boolean {
    val emailRegex = "^[A-Za-z0-9+_.-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,}$".toRegex()
    return this.matches(emailRegex)
}

/**
 * Extract hashtags from text
 */
fun String.extractHashtags(): List<String> {
    val regex = AppConstants.HASHTAG_PATTERN.toRegex()
    return regex.findAll(this).map { it.value.removePrefix("#") }.toList()
}

/**
 * Extract mentions from text
 */
fun String.extractMentions(): List<String> {
    val regex = AppConstants.MENTION_PATTERN.toRegex()
    return regex.findAll(this).map { it.value.removePrefix("@") }.toList()
}

/**
 * Truncate string to max length
 */
fun String.truncate(maxLength: Int, ellipsis: String = "..."): String {
    return if (this.length > maxLength) {
        this.take(maxLength - ellipsis.length) + ellipsis
    } else {
        this
    }
}

/**
 * Format number to compact form (1K, 1M, etc.)
 */
fun Long.toCompactString(): String {
    return when {
        this < 1000 -> this.toString()
        this < 1_000_000 -> {
            val value = (this / 100.0).toInt() / 10.0
            "${value}K"
        }
        this < 1_000_000_000 -> {
            val value = (this / 100_000.0).toInt() / 10.0
            "${value}M"
        }
        else -> {
            val value = (this / 100_000_000.0).toInt() / 10.0
            "${value}B"
        }
    }
}

/**
 * Format number to compact form
 */
fun Int.toCompactString(): String = this.toLong().toCompactString()
